module.exports = __webpack_public_path__ + "img/zoom_setting_7.5f456dd5.jpg";